import { render, staticRenderFns } from "./createAgentApp.vue?vue&type=template&id=60ba1f9f&scoped=true&"
import script from "./createAgentApp.vue?vue&type=script&lang=js&"
export * from "./createAgentApp.vue?vue&type=script&lang=js&"
import style0 from "./createAgentApp.vue?vue&type=style&index=0&id=60ba1f9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba1f9f",
  null
  
)

export default component.exports